import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, formatError } from "@/lib/api";

const DEFAULTS = { shift_reminders: true, reminder_minutes_before: 60, clockout_nudges: true, expiry_alerts: true };
const ROWS = [
  ["shift_reminders", "Shift reminders", "Email staff before each published rostered shift."],
  ["clockout_nudges", "Forgot-to-clock-out nudges", "Email staff still clocked in 30 minutes after their rostered finish, or after 10 hours with no rostered shift."],
  ["expiry_alerts", "Document expiry alerts", "Notify staff and managers, and email managers, when a licence or certificate is within 30 days of expiring."],
];

export const RemindersForm = ({ business, onSaved }) => {
  const [f, setF] = useState({ ...DEFAULTS, ...(business.settings?.reminders || {}) });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await api.patch("/business/settings", { reminders: f }); toast.success("Reminder settings saved"); onSaved(); } catch (e) { toast.error(formatError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="max-w-2xl space-y-3" data-testid="reminders-form">
      {ROWS.map(([k, t, d]) => (
        <div key={k} className="flex items-start justify-between gap-4 rounded-xl border border-slate-200 p-4">
          <div><p className="text-sm font-semibold">{t}</p><p className="text-xs text-slate-500">{d}</p>
            {k === "shift_reminders" && f.shift_reminders && (
              <div className="mt-2 flex items-center gap-2 text-xs text-slate-600">Send
                <Select value={String(f.reminder_minutes_before)} onValueChange={(v) => setF({ ...f, reminder_minutes_before: Number(v) })}>
                  <SelectTrigger className="h-8 w-32 rounded-lg" data-testid="reminder-minutes-select"><SelectValue /></SelectTrigger>
                  <SelectContent>{[[30, "30 minutes"], [60, "1 hour"], [120, "2 hours"], [180, "3 hours"]].map(([v, l]) => <SelectItem key={v} value={String(v)}>{l}</SelectItem>)}</SelectContent>
                </Select>before the shift starts</div>)}
          </div>
          <Switch checked={f[k]} onCheckedChange={(v) => setF({ ...f, [k]: v })} data-testid={`reminder-toggle-${k}`} />
        </div>))}
      <p className="text-xs text-slate-500">Reminders are checked every 15 minutes. In-app announcement and leave notifications always stay on.</p>
      <Button onClick={save} disabled={busy} className="rounded-full bg-[#00A85C] hover:bg-[#008F4F]" data-testid="reminders-save-btn">Save reminder settings</Button>
    </div>
  );
};
